import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import { drawerWidth } from 'store/constant';

const openedMixin = (theme) => ({
    width: drawerWidth,
    background: theme.palette.background.default,
    borderRight: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: 300
    }),
    overflowX: 'hidden',
    boxShadow: theme.palette.mode === 'dark' ? '0px 3px 10px rgba(0, 0, 0, 0.2)' : '0px 3px 10px rgba(144, 202, 249, 0.2)',
    height: '100%',
    '& .MuiList-root': {
        padding: theme.spacing(2)
    },
    '& .MuiListItemButton-root': {
        margin: '4px 0',
        borderRadius: theme.shape.borderRadius,
        '&:hover': {
            backgroundColor: `${theme.palette.primary.light}20`
        }
    },
    '& .MuiListItemIcon-root': {
        minWidth: 40,
        color: theme.palette.primary.main,
        '& svg': {
            fontSize: '1.25rem'
        }
    }
});

const closedMixin = (theme) => ({
    width: 72,
    background: theme.palette.background.default,
    borderRight: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: 300
    }),
    overflowX: 'hidden',
    boxShadow: theme.palette.mode === 'dark' ? '0px 3px 10px rgba(0, 0, 0, 0.2)' : '0px 3px 10px rgba(144, 202, 249, 0.2)',
    height: '100%',
    '& .MuiList-root': {
        padding: theme.spacing(2, 1)
    },
    '& .MuiListItemButton-root': {
        margin: '4px auto',
        borderRadius: theme.shape.borderRadius,
        width: '90%',
        padding: theme.spacing(1),
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: `${theme.palette.primary.light}20`
        }
    },
    '& .MuiListItemIcon-root': {
        minWidth: 'auto',
        color: theme.palette.primary.main,
        '& svg': {
            fontSize: '1.25rem'
        }
    }
});

const MiniDrawerStyled = styled(Drawer, {
    shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': {
            ...openedMixin(theme),
            '& .MuiListItemIcon-root': {
                transition: theme.transitions.create(['transform'], {
                    duration: 200
                })
            },
            '& .MuiListItemButton-root:hover .MuiListItemIcon-root': {
                transform: 'scale(1.1)',
                color: theme.palette.primary.dark
            }
        }
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': {
            ...closedMixin(theme),
            '& .MuiListItemIcon-root': {
                transition: theme.transitions.create(['transform'], {
                    duration: 200
                })
            },
            '& .MuiListItemButton-root:hover .MuiListItemIcon-root': {
                transform: 'scale(1.1)',
                color: theme.palette.primary.dark
            }
        }
    }),
    '& .MuiDrawer-paper': {
        position: 'static',
        '&::-webkit-scrollbar': {
            width: '4px',
            backgroundColor: 'transparent'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.primary.light,
            borderRadius: '4px'
        }
    }
}));

export default MiniDrawerStyled;
